<template>
    <div>
        <ul class="flex row wrap unstyled">
            <li v-for="repo in repos" :key="repo.id" class="flex-item github-badge z-depth-1">
                <a :href="repo.html_url" :title="repo.description">
                    <div class="title"><span class="badge right" v-if="repo.language">{{repo.language}}</span>{{repo.name}}</div>
                    <div class="description">{{repo.description}}</div>
                    <div class="flex row badges">
                        <div class="flex-item fa fa-star">&nbsp;{{repo.stargazers_count}}</div>
                        <div class="flex-item fa fa-eye">&nbsp;{{repo.watchers_count}}</div>
                        <div class="flex-item fas fa-code-branch">&nbsp;{{repo.forks}}</div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import {Request,StorageMode } from '../Ajax';

export default Vue.defineComponent({
    data: function(){
        return {
            repos: []
        };
    },
    methods: {
        loadData: function() {
            let that = this;
            Request.get('https://api.github.com/users/JaCraig/repos?per_page=100')
                    .onSuccess(value=>{
                        that.repos = value.filter(repo=>!repo.fork)
                                .sort((item1,item2)=>{
                                    if(item1.stargazers_count>item2.stargazers_count) {
                                        return -1;
                                    } else if(item1.stargazers_count<item2.stargazers_count) {
                                        return 1;
                                    }
                                    if(item1.watchers_count>item2.watchers_count) {
                                        return -1;
                                    } else if(item1.watchers_count<item2.watchers_count) {
                                        return 1;
                                    }
                                    if(item1.name.toLowerCase()>item2.name.toLowerCase()) {
                                        return 1;
                                    }
                                    if(item1.name.toLowerCase()<item2.name.toLowerCase()) {
                                        return -1;
                                    }
                                    return 0;
                                });
            })
            .onError(value=>console.log(value))
            .setMode(StorageMode.StorageAndUpdate)
            .send();
        }
    },
    beforeMount: function() {
        this.loadData();
    }
})
</script>